import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { TipoClienteModel } from 'app/model/cliente/tipocliente.model';
import { TipoReajusteModel } from 'app/model/cliente/tiporeajuste.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TiporeajusteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageTipoReajuste(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-tiporeajuste?page=${page}&size=${size}`, this.httpOptions);
  }

  getTipoReajuste(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-tiporeajuste', this.httpOptions);
  }

  postTipoReajuste(tipoReajuste: TipoReajusteModel): Observable<TipoReajusteModel>{
    return this.httpClient.post<TipoReajusteModel>(this.apiURL + '/new/adicionar-tiporeajuste', tipoReajuste, this.httpOptions);
  }

  deleteTipoReajuste(id: any) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-tiporeajuste/' + id, { headers, responseType: 'text' });
  }

  putTipoReajuste(tipoReajuste: TipoReajusteModel): Observable<TipoReajusteModel>{
    return this.httpClient.put<TipoReajusteModel>(this.apiURL + '/edit/editar-tiporeajuste', tipoReajuste, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/tiporeajuste.service.ts